"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var moment_1 = __importDefault(require("moment"));
var lodash_1 = __importDefault(require("lodash"));
TripsEditController.$inject = ['$scope', '_trip', '$state', 'notify', 'trip', '$timeout'];
function TripsEditController($scope, _trip, $state, notify, trip, $timeout) {
    var self = this;
    $scope.show_routes = false;
    $scope.optimized_route_id = null;
    $scope.loading_optimize_route = false;
    $scope.saving = false;
    $scope.init_watch = true;
    $scope.errorMessages = [];
    $scope.trip = lodash_1.default.create(trip);
    var _format_date = 'YYYY-MM-DD HH:mm:ss';
    $scope.setAharbour = function (id) {
        $scope.mapAharbour = lodash_1.default.find($scope.harbours, function (h) {
            return h.id === id;
        });
    };
    $scope.setDharbour = function (id) {
        $scope.mapDharbour = lodash_1.default.find($scope.harbours, function (h) {
            return h.id === id;
        });
    };
    if (!trip.id) {
        $scope.trip.status = 0;
        $scope.trip.fc = 0;
        $scope.trip.cid = 0;
        $scope.trip.atime = moment_1.default().utc().minutes(0).seconds(0).format(_format_date);
        $scope.trip.dtime = moment_1.default().utc().minutes(0).seconds(0).format(_format_date);
        $scope.mapAharbour = {};
        $scope.mapDharbour = {};
        $scope.route_option = 1;
        $scope.route = null;
        $scope.is_new = true;
    }
    else {
        if (trip.status === 1 || trip.status === 2) {
            $state.go('trips');
        }
        $scope.show_routes = true;
        $scope.trip.atime = moment_1.default(trip.atime).format(_format_date);
        $scope.trip.dtime = moment_1.default(trip.dtime).format(_format_date);
        $timeout(function () {
            $scope.setAharbour($scope.trip.aharbour);
            $scope.setDharbour($scope.trip.dharbour);
            $scope.is_new = false;
            if ($scope.init_watch) {
                $scope.$watch('route_option', function (nval, oval) {
                    if (nval === 1 && oval !== 2) {
                        getOptimizedRoute();
                        $scope.init_watch = false;
                    }
                });
            }
            if (trip.planned_route_id) {
                _trip.getPlannedRoute(trip.planned_route_id).then(function (response) {
                    var planned_route = _trip.unpackRoute(response);
                    if (planned_route.optimized_route_id) {
                        $scope.route_option = 1;
                    }
                    else {
                        $scope.route_option = 2;
                    }
                    $scope.route = planned_route.route;
                });
            }
        }, 300);
    }
    _trip.fetchShips().then(function (response) {
        $scope.ships = response;
    }, function (error) {
        console.log(error);
    });
    _trip.fetchHarbours().then(function (response) {
        $scope.harbours = response;
    }, function (error) {
        console.log(error);
    });
    $scope.exit = function () {
        $state.go('trips');
    };
    $scope.loadRoute = function () {
        $scope.errorMessages = [];
        var atime = new Date($scope.trip.atime);
        var dtime = new Date($scope.trip.dtime);
        if (dtime.getTime() >= atime.getTime()) {
            $scope.errorMessages.push('Arrival time must be greater than departure time.');
        }
        else {
            $scope.show_routes = true;
            $scope.route = null;
            $scope.errorMessages = [];
            if (!trip._id) {
                getOptimizedRoute();
            }
        }
    };
    function getOptimizedRoute() {
        $scope.loading_optimize_route = true;
        var ship = lodash_1.default.find($scope.ships, { id: $scope.trip.ship });
        var aharbour = lodash_1.default.find($scope.harbours, { id: $scope.trip.aharbour });
        var dharbour = lodash_1.default.find($scope.harbours, { id: $scope.trip.dharbour });
        var data = {
            dlat: dharbour.lat,
            dlon: dharbour.lon,
            dtime: $scope.trip.dtime,
            alat: aharbour.lat,
            alon: aharbour.lon,
            atime: $scope.trip.atime,
            si: ship.si,
            mw: 100,
            speed: 9
        };
        _trip.getOptimizedRoute(data).then(function (response) {
            $scope.loading_optimize_route = false;
            $scope.optimized_route = _trip.unpackRoute(response);
            $scope.route = $scope.optimized_route.route;
        }, function (error) {
            $scope.loading_optimize_route = false;
            console.log(error);
        });
    }
    ;
    $scope.edit = function () {
        $scope.route_option = 1;
        $scope.show_routes = false;
        $scope.route = null;
    };
    $scope.selectRouteValue = function () {
        $scope.route_option = $scope.route_option === 1 ? 2 : 1;
        $scope.route = null;
        if ($scope.route_option === 1) {
            getOptimizedRoute();
        }
    };
    $scope.clearRoute = function () {
        $scope.route = null;
    };
    $scope.checkSelectedHarbour = function () {
        if ($scope.trip.aharbour === $scope.trip.dharbour) {
            $scope.errorMessages.push('Harbours must be different.');
            $scope.trip.aharbour = null;
        }
        else {
            $scope.errorMessages = [];
        }
    };
    // $scope.unpackRoute = _route => {
    //     let route = _.omit(_route, ['route']);
    //     let i = 1;
    //     route.route = _.map(JSON.parse(atob(_route.route)), (r) => {
    //         return {
    //             wpt: i++,
    //             lon: r.longitude,
    //             lat: r.latitude,
    //             eta: moment.utc(r.time),
    //             distance: r.extensions.distance,
    //             bearing: r.extensions.bearing,
    //             speed: r.extensions.speed,
    //         }
    //     });
    //     return route;
    // };
    // $scope.packRoute = route => {
    //     var temp = [];
    //     _.each(route, function(val, idx) {
    //         temp.push({
    //             latitude: val.lat,
    //             longitude: val.lon,
    //             elevation: 0,
    //             time: val.eta.format('YYYY-MM-DDTHH:mm:ss[Z]'),
    //             extensions: {
    //                 distance: val.distance,
    //                 bearing: val.bearing,
    //                 speed: val.speed,
    //                 fuel: 0,
    //                 v_component_of_wind: "-nan",
    //                 u_component_of_wind: "-nan",
    //                 v_component_Significant_height_of_combined_wind_waves_and_swell: "-nan",
    //                 u_component_Significant_height_of_combined_wind_waves_and_swell: "-nan",
    //                 Mean_period_of_wind_waveseight_of_combined_wind_waves_and_swell: "-nan"
    //             }
    //         });
    //     });
    //     return btoa(JSON.stringify(temp));
    // };
    $scope.save = function () {
        $scope.saving = true;
        var route_data = {
            trip_id: null,
            optimized_route_id: null,
            route: null
        };
        route_data.route = _trip.packRoute($scope.route);
        _trip.save(trip, $scope.trip)
            .then(function (response) {
            route_data.trip_id = trip.id || response.id;
            if ($scope.route_option === 1) {
                route_data.optimized_route_id = $scope.optimized_route.id;
            }
            _trip.saveRoute(route_data).then(function (route) {
                $scope.saving = false;
                notify.success('You have successfully saved the data.');
                $scope.exit();
            }, function (error) {
                $scope.saving = false;
                console.log(error);
                notify.error('Route not saved.');
            });
        }, function (error) {
            $scope.saving = false;
            notify.error(error.data);
            console.log(error);
        });
    };
}
exports.TripsEditController = TripsEditController;



//////////////////
// WEBPACK FOOTER
// ./scripts/apps/trips/controllers/TripsEditController.ts
// module id = 563
// module chunks = 0